import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import DocumentSchema from '@/components/DocumentSchema';
import type { Table } from 'schema-dts';
import { selector } from '@/pages/CompanyReport/components/Valuation';
import { shallowEqual, useSelector } from 'react-redux';

export const FairRatioTable = () => {
  const {
    tickerSymbol,
    multiples: { preferredMultiple },
    formattedPreferredMultipleFairRatio,
  } = useSelector<Parameters<typeof selector>[0], ReturnType<typeof selector>>(
    selector,
    shallowEqual
  );
  const header = `Fair Ratio`;
  const caption = `${tickerSymbol} ${preferredMultiple.name} Ratio vs Fair Ratio.`;
  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: header,
          about: caption,
        }}
      />
      <ChartDataTable data-cy-id="key-metrics-table" columnTextAlignments="l">
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th colSpan={2}>{header}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{`Current ${preferredMultiple.name} Ratio`}</td>
            <td>{preferredMultiple.value}</td>
          </tr>
          <tr>
            <td>{`Fair ${preferredMultiple.name} Ratio`}</td>
            <td>{formattedPreferredMultipleFairRatio}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};
